<template>
    <div style="text-align:center; padding: 50px 0;"><a-spin size="large" /></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { Spin } from "ant-design-vue";

export default defineComponent({
    components: {
        ASpin: Spin,
    },
});
</script>
